import {toast} from "react-toastify";

export function showErrorToast(message: string) {
    toast(message,  { type: 'error', position: 'top-right' });
}

export function showSuccessToast(message: string) {
    toast(message,  { type: 'success', position: 'bottom-right', hideProgressBar: true, autoClose: 2000 });
}